// Belonge — photoreal fabric renderer. Transparent background; PBR knit with sheen.
(function () {
  const CACHE = {};

  function knitHeightMap(size, cols, rows) {
    const c = document.createElement('canvas');
    c.width = c.height = size;
    const x = c.getContext('2d');
    x.fillStyle = '#6a6a6a';
    x.fillRect(0, 0, size, size);
    const cw = size / cols, ch = size / rows;
    x.lineCap = 'round';
    x.lineJoin = 'round';
    for (let r = -1; r < rows + 1; r++) {
      for (let i = -1; i < cols + 1; i++) {
        const ox = (r % 2 ? cw * 0.5 : 0) + i * cw, oy = r * ch;
        x.strokeStyle = '#dedede';
        x.lineWidth = cw * 0.34;
        x.beginPath();
        x.moveTo(ox, oy + ch * 0.98);
        x.quadraticCurveTo(ox + cw * 0.5, oy - ch * 0.12, ox + cw, oy + ch * 0.98);
        x.stroke();
        x.strokeStyle = '#9a9a9a';
        x.lineWidth = cw * 0.16;
        x.beginPath();
        x.moveTo(ox + cw * 0.04, oy + ch * 1.0);
        x.quadraticCurveTo(ox + cw * 0.5, oy - ch * 0.04, ox + cw * 0.96, oy + ch * 1.0);
        x.stroke();
        x.strokeStyle = '#343434';
        x.lineWidth = cw * 0.075;
        x.beginPath();
        x.moveTo(ox + cw * 0.5, oy + ch * 0.02);
        x.lineTo(ox + cw * 0.5, oy + ch * 0.42);
        x.stroke();
      }
    }
    const im = x.getImageData(0, 0, size, size), d = im.data;
    for (let i = 0; i < d.length; i += 4) {
      const n = (Math.random() - 0.5) * 30;
      d[i] += n; d[i + 1] += n; d[i + 2] += n;
    }
    x.putImageData(im, 0, 0);
    return c;
  }

  function toNormal(src, strength) {
    const s = src.width;
    const out = document.createElement('canvas');
    out.width = out.height = s;
    const sc = src.getContext('2d').getImageData(0, 0, s, s).data;
    const octx = out.getContext('2d');
    const oc = octx.createImageData(s, s);
    const od = oc.data;
    for (let j = 0; j < s; j++) {
      const jm = ((j - 1 + s) % s) * s, jp = ((j + 1) % s) * s, jc = j * s;
      for (let i = 0; i < s; i++) {
        const im = (i - 1 + s) % s, ip = (i + 1) % s;
        const dx = (sc[(jc + ip) * 4] - sc[(jc + im) * 4]) / 255 * strength;
        const dy = (sc[(jp + i) * 4] - sc[(jm + i) * 4]) / 255 * strength;
        const len = Math.sqrt(dx * dx + dy * dy + 1);
        const k = (jc + i) * 4;
        od[k] = ((-dx / len) * 0.5 + 0.5) * 255;
        od[k + 1] = ((-dy / len) * 0.5 + 0.5) * 255;
        od[k + 2] = ((1 / len) * 0.5 + 0.5) * 255;
        od[k + 3] = 255;
      }
    }
    octx.putImageData(oc, 0, 0);
    return out;
  }

  function maps(T, key, size, cols, rows, strength) {
    if (CACHE[key]) return CACHE[key];
    const height = knitHeightMap(size, cols, rows);
    const normal = new T.CanvasTexture(toNormal(height, strength));
    const rough = new T.CanvasTexture(height);
    [normal, rough].forEach(t => { t.wrapS = t.wrapT = T.RepeatWrapping; });
    CACHE[key] = { normal, rough };
    return CACHE[key];
  }

  function studioEnv(T, renderer) {
    const c = document.createElement('canvas');
    c.width = 1024; c.height = 512;
    const x = c.getContext('2d');
    const g = x.createLinearGradient(0, 0, 0, 512);
    g.addColorStop(0, '#ffffff');
    g.addColorStop(0.4, '#ded7ca');
    g.addColorStop(0.6, '#6b6459');
    g.addColorStop(1, '#171510');
    x.fillStyle = g; x.fillRect(0, 0, 1024, 512);
    [[250, 140, 230, 90], [740, 190, 160, 70], [520, 60, 300, 60]].forEach(([cx, cy, rx, ry]) => {
      const rg = x.createRadialGradient(cx, cy, 0, cx, cy, rx);
      rg.addColorStop(0, 'rgba(255,252,246,1)');
      rg.addColorStop(1, 'rgba(255,252,246,0)');
      x.save(); x.translate(cx, cy); x.scale(1, ry / rx); x.translate(-cx, -cy);
      x.fillStyle = rg; x.beginPath(); x.arc(cx, cy, rx, 0, 6.284); x.fill(); x.restore();
    });
    const tex = new T.CanvasTexture(c);
    tex.mapping = T.EquirectangularReflectionMapping;
    tex.colorSpace = T.SRGBColorSpace;
    const pmrem = new T.PMREMGenerator(renderer);
    const env = pmrem.fromEquirectangular(tex).texture;
    pmrem.dispose(); tex.dispose();
    return env;
  }

  window.__belongeScene = function (canvas, mode, opts) {
    const T = window.THREE;
    if (!T) return null;
    const o = opts || {};
    const macro = mode === 'macro';
    const renderer = new T.WebGLRenderer({ canvas, alpha: true, antialias: true, powerPreference: 'high-performance' });
    renderer.setPixelRatio(Math.min(devicePixelRatio, macro ? 2 : 2.5));
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;
    const maxAniso = renderer.capabilities.getMaxAnisotropy();

    const scene = new T.Scene();
    scene.environment = studioEnv(T, renderer);
    const camera = new T.PerspectiveCamera(36, 1, 0.1, 100);
    camera.position.set(0, 0, 7.4);

    const key = new T.DirectionalLight(0xfff3e4, 1.55); key.position.set(3.5, 5, 6); scene.add(key);
    const fill = new T.DirectionalLight(0xa8b0c0, 0.5); fill.position.set(-5, -1, 2); scene.add(fill);

    const group = new T.Group(); scene.add(group);

    const M = macro
      ? maps(T, 'macro', 1024, 22, 30, 3.2)
      : maps(T, 'knit4k', 2048, 56, 74, 3.8);

    const uTime = { value: 0 };
    const cloth = o.color != null ? o.color : 0xd6cec0;

    function fabricMaterial(repeat, normalScale) {
      const n = M.normal.clone(); n.needsUpdate = true; n.repeat.set(repeat[0], repeat[1]); n.anisotropy = maxAniso;
      const r = M.rough.clone(); r.needsUpdate = true; r.repeat.set(repeat[0], repeat[1]); r.anisotropy = maxAniso;
      return new T.MeshPhysicalMaterial({
        color: cloth,
        roughness: 0.76, metalness: 0.0,
        sheen: 1.0, sheenRoughness: 0.4, sheenColor: new T.Color(0xffd9b8),
        normalMap: n, normalScale: new T.Vector2(normalScale, normalScale),
        roughnessMap: r,
        envMapIntensity: 1.15,
        side: T.DoubleSide
      });
    }

    if (macro) {
      const yarnMat = fabricMaterial([14, 1.6], 0.55);
      const yarnMat2 = fabricMaterial([14, 1.6], 0.55);
      yarnMat2.color = new T.Color(o.color2 != null ? o.color2 : 0xa65b3e);
      const n = 9, step = 0.52, span = n * step, amp = 0.19;
      for (let i = 0; i < n; i++) {
        const off = -span / 2 + i * step + step / 2;
        for (const axis of ['x', 'z']) {
          const pts = [];
          for (let k = 0; k <= 26; k++) {
            const t = -span / 2 + (k / 26) * span;
            const y = amp * Math.sin(t * 6.05 + (axis === 'x' ? 0 : Math.PI) + i * Math.PI);
            pts.push(axis === 'x' ? new T.Vector3(t, y, off) : new T.Vector3(off, -y, t));
          }
          const g = new T.TubeGeometry(new T.CatmullRomCurve3(pts), 44, 0.135, 12, false);
          group.add(new T.Mesh(g, axis === 'z' && i % 3 === 0 ? yarnMat2 : yarnMat));
        }
      }
      const drop = new T.MeshPhysicalMaterial({
        color: 0xffffff, roughness: 0.02, metalness: 0,
        transmission: 1, thickness: 0.22, ior: 1.33, transparent: true, envMapIntensity: 1.4
      });
      [[-0.9, 0.55], [0.35, -0.7], [1.25, 0.9], [-1.5, -1.1], [0.05, 1.35], [-0.35, -0.15]].forEach(([bx, bz], i) => {
        const s = 0.1 + (i % 3) * 0.038;
        const m = new T.Mesh(new T.SphereGeometry(s, 24, 18), drop);
        m.scale.y = 0.72;
        m.position.set(bx, amp + s * 0.55, bz);
        m.userData.phase = i * 1.1;
        group.add(m);
      });
      group.rotation.x = 0.42;
      camera.position.set(0, 1.1, 5.4);
      camera.lookAt(0, 0, 0);
    } else {
      const W = 3.0, H = 4.3;
      const geo = new T.PlaneGeometry(W, H, 200, 260);
      const mat = fabricMaterial([6, 8], 0.9);
      const wind = `
uniform float uTime;
vec3 belWind(vec3 p) {
  float v = (p.y + ${(H / 2).toFixed(3)}) / ${H.toFixed(3)};
  float pinch = 1.0 - 0.42 * v * v;
  float x = p.x * pinch;
  float fold = sin(x * 5.4) * 0.30 * (1.0 - v * 0.72)
             + sin(x * 11.2 + 1.1) * 0.07 * (1.0 - v);
  float amp = 1.0 - v * 0.84;
  float gust = 0.55 + 0.45 * sin(uTime * 0.23);
  float w = sin(x * 2.4 + uTime * 1.15) * 0.115
          + sin(p.y * 1.9 - uTime * 0.82 + x * 0.75) * 0.072
          + sin(x * 5.1 - uTime * 1.72 + p.y * 0.6) * 0.034
          + sin(p.y * 3.4 + uTime * 2.35) * 0.016;
  w *= gust;
  float z = fold - 0.18 * (1.0 - v) - 0.05 * v + w * amp;
  float y = p.y - 0.12 * cos(x * 5.4) * (1.0 - v) * 0.4 - abs(w) * 0.16 * amp;
  return vec3(x + w * 0.24 * amp, y, z);
}
`;
      mat.onBeforeCompile = (sh) => {
        sh.uniforms.uTime = uTime;
        sh.vertexShader = wind + sh.vertexShader
          .replace('#include <beginnormal_vertex>', `
            vec3 belP0 = belWind(position);
            vec3 belPx = belWind(position + vec3(0.015, 0.0, 0.0));
            vec3 belPy = belWind(position + vec3(0.0, 0.015, 0.0));
            vec3 objectNormal = normalize(cross(belPx - belP0, belPy - belP0));
            #ifdef USE_TANGENT
              vec3 objectTangent = vec3( tangent.xyz );
            #endif
          `)
          .replace('#include <begin_vertex>', 'vec3 transformed = belP0;');
      };
      group.add(new T.Mesh(geo, mat));
      group.rotation.y = -0.22;
      group.position.y = 0.08;
    }

    let raf = 0, visible = true, w = 0, h = 0;
    const t0 = performance.now();
    const pointer = { x: 0, y: 0 };
    function onMove(e) {
      const r = canvas.getBoundingClientRect();
      if (!r.width) return;
      pointer.x = ((e.clientX - r.left) / r.width - 0.5) * 2;
      pointer.y = ((e.clientY - r.top) / r.height - 0.5) * 2;
    }
    window.addEventListener('pointermove', onMove, { passive: true });
    function resize() {
      const r = canvas.getBoundingClientRect();
      const nw = Math.round(r.width), nh = Math.round(r.height);
      if (!nw || !nh || (nw === w && nh === h)) return;
      w = nw; h = nh;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    }
    const ro = new ResizeObserver(resize); ro.observe(canvas); resize();
    document.addEventListener('visibilitychange', () => { if (!document.hidden && visible && !raf) loop(); });
    const io = new IntersectionObserver((es) => {
      visible = es[0].isIntersecting;
      if (visible && !raf) loop();
    }, { rootMargin: '150px' });
    io.observe(canvas);

    function loop() {
      if (!visible || document.hidden) { raf = 0; return; }
      raf = requestAnimationFrame(loop);
      const t = (performance.now() - t0) / 1000;
      uTime.value = t;
      if (macro) {
        group.rotation.y = Math.sin(t * 0.13) * 0.5 + pointer.x * 0.25;
        group.rotation.x = 0.42 + pointer.y * 0.07;
        group.children.forEach((m) => {
          if (m.userData.phase !== undefined) m.position.y += Math.sin(t * 1.4 + m.userData.phase) * 0.0006;
        });
      } else {
        group.rotation.y = -0.22 + Math.sin(t * 0.15) * 0.2 + pointer.x * 0.2;
        group.rotation.x = pointer.y * -0.05;
      }
      renderer.render(scene, camera);
    }
    loop();

    return {
      canvas,
      dispose() {
        cancelAnimationFrame(raf); visible = false;
        ro.disconnect(); io.disconnect();
        window.removeEventListener('pointermove', onMove);
        renderer.dispose();
      }
    };
  };
})();